import { createLookupStore, type LookupStore } from '@botto/core';
import { fetchCdpProjects, type CdpProjectOption } from '../api/services/cdpProjects';

let _cdpProjects: LookupStore<CdpProjectOption> | undefined;

export function getCdpProjectsLookup(): LookupStore<CdpProjectOption> {
  if (!_cdpProjects) {
    _cdpProjects = createLookupStore<CdpProjectOption>(fetchCdpProjects, {
      idField: 'id',
      labelField: 'name',
    });
  }
  return _cdpProjects;
}
